<template>
  <div class="card">
    <header v-if="title" class="card-header">
      <p class="card-header-title title-main">
        <!-- <b-icon v-if="icon" pack="fas" :icon="icon" custom-size="default" /> -->
        {{ title }}
<!-- {{searchT}} -->
        <select v-if="title=='Users'" v-model="searchT" @change="searchRoles" class="autocomplete-input search-types" >
                <option value='0' v-if="this.$store.state.auth.user.role == '0'" >Super Admin</option>
                <option value='1'>Admin</option>
                <option value='2'>Data Admin</option>
                <option value='3'>Data Clerk</option>
                <option value='4'>Analytics</option>
                <option value='99'>All</option>
       </select>
      </p>
      <a
        v-if="headerIcon"
        href="#"
        class="card-header-icon"
        aria-label="more options"
        @click.prevent="headerIconClick"
      >
        <b-icon :icon="headerIcon" custom-size="default" />
      </a>
    </header>
    <div class="card-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardComponent',
  props: {
    title: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    headerIcon: {
      type: String,
      default: null,
    },
    searchT: {
      type: String,
      default: '1'
    }
  },
  methods: {
    headerIconClick() {
      this.$emit('header-icon-click');
    },
    searchRoles(){
      this.$emit('roleChanged', this.searchT);
    },
  },
};
</script>

<style scoped lang="scss">
.title-main{
  display: flex;
  justify-content: space-between;
}
.search-types{
      max-width: 150px;
  background-image: none;
  padding-left: 12px;
}
</style>
